var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "修改订单信息",
        visible: _vm.dialogVisible,
        "before-close": _vm.closeDialog,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.form, "label-width": "150px", rules: _vm.rules },
        },
        [
          _vm.rowInfo.editStatus == "edit"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "收件人姓名", prop: "receiveName" } },
                  [
                    _c("el-input", {
                      staticClass: "y-w-300",
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.receiveName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "receiveName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.receiveName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    ref: "receiveMobile",
                    attrs: { label: "收件人手机", prop: "receiveMobile" },
                  },
                  [
                    _c("el-input", {
                      staticClass: "y-w-300",
                      attrs: { maxlength: 11, clearable: "" },
                      model: {
                        value: _vm.form.receiveMobile,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "receiveMobile",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.receiveMobile",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    ref: "receivePhone",
                    attrs: { label: "收件人电话", prop: "receivePhone" },
                  },
                  [
                    _c("el-input", {
                      staticClass: "y-w-300",
                      attrs: { maxlength: 20, clearable: "" },
                      model: {
                        value: _vm.form.receivePhone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "receivePhone",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.receivePhone",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c("div", { staticClass: "y-mb-20" }, [
                  _vm._v(
                    "当前消费者期望上门时间已过可服务时间，请与消费者沟通后重新选择上门取件时间"
                  ),
                ]),
              ],
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  _vm.rowInfo.editStatus == "edit"
                    ? "取件时间"
                    : "上门取件时间",
                prop: "reciveTime",
              },
            },
            [
              _c("selectTime", {
                ref: "selectTime",
                staticClass: "y-w-300",
                attrs: {
                  typeFlag: _vm.form.pickupOrderChannel == "0" ? "1" : "2",
                  curTime: _vm.form.reciveTime,
                  receiveAddressInfo: _vm.receiveAddressInfo,
                },
                on: { selectedTime: _vm.selectedTimeFn },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeDialog } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.modifyFn } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }